export default "/bitrix/js/landing/ui/panel/formsettingspanel/content/fields/dist/images/message-icon.svg"